import ReportRedeemDonationPoints from './ReportRedeemDonationPoints.vue'

export default {
  ReportRedeemDonationPoints
}



// WEBPACK FOOTER //
// ./src/components/Reports/index.js